import React, { useState } from 'react';
import { ModalBody, ModalCloseBtn, ModalContent, ModalFooter, ModalHeader, Modal } from '@fiverr-private/overlay';
import { Button } from '@fiverr-private/button';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';
import {
    UpgradeSuggestion,
    reportClickedProUpgradeBackButton,
    reportClickedProSubscriptionAdvancedUpsell,
    setUpgradeQueryParams,
} from '@fiverr-private/upsell';
import { useUpgradeStep } from '@fiverr-private/plan_change';
import { useComplianceContext } from '../ComplianceProvider/context';
import { ComplianceType } from '../ComplianceModal/types';
import { useSellerConfigData } from '../../api/useSellerConfigData';

export function SuccessStepModalContent({
    canUpgradeToPro = false,
    sellerId,
    sellerName,
    isOpen,
    onClose,
    fromComplianceType,
}: {
    canUpgradeToPro?: boolean;
    sellerId: number;
    sellerName: string;
    isOpen?: boolean;
    onClose: () => void;
    fromComplianceType: ComplianceType;
}) {
    const ComplianceContext = useComplianceContext();
    const { isUsSeller } = useSellerConfigData(sellerId);
    const [shouldShowUpgradeFlow, setShouldShowUpgradeFlow] = useState(false);

    const upsellBiData = {
        sellerId,
        upgradeSource: fromComplianceType,
        pageName: ComplianceContext?.pageName || '',
    };

    const UpgradeStep = useUpgradeStep({
        title: translate(`compliance.upsale.${fromComplianceType}.title`),
        onBack: () => {
            setShouldShowUpgradeFlow(false);
            reportClickedProUpgradeBackButton(upsellBiData);
        },
        biEvents: upsellBiData,
        redirectUrl: setUpgradeQueryParams(sellerId, sellerName, fromComplianceType),
        isUsSeller,
    });

    if (!ComplianceContext) return null;
    return (
        <Modal centered={!shouldShowUpgradeFlow} onClose={onClose} isOpen={isOpen}>
            <ModalContent size={shouldShowUpgradeFlow ? 'xl' : 'sm'}>
                <ModalHeader>
                    <ModalCloseBtn onClick={ComplianceContext.closeModal} />
                </ModalHeader>

                {shouldShowUpgradeFlow ? (
                    UpgradeStep
                ) : (
                    <>
                        <ModalBody>
                            <Typography size="h_lg" fontWeight="bold" color="black" paddingBottom="3">
                                <I18n k={`compliance.success_modal.title`} />
                            </Typography>
                            <Typography textAlign="center" color="grey_1200" paddingBottom="6">
                                <I18n k={`compliance.success_modal.body`} params={{ sellerName }} />
                            </Typography>
                            <Button onClick={ComplianceContext.closeModal}>
                                <I18n k={`compliance.success_modal.action`} />
                            </Button>
                        </ModalBody>

                        {canUpgradeToPro && (
                            <ModalFooter>
                                <UpgradeSuggestion
                                    onClickUpgrade={() => {
                                        setShouldShowUpgradeFlow(true);
                                        reportClickedProSubscriptionAdvancedUpsell(upsellBiData);
                                    }}
                                    body={translate(`compliance.success_modal.${fromComplianceType}.body`)}
                                />
                            </ModalFooter>
                        )}
                    </>
                )}
            </ModalContent>
        </Modal>
    );
}
